import "./input-number/index";
import "./input-slide/index";
import "./input-select/index";
